import React from 'react';
import { Box } from '@mui/material';
import { readableText, statusColor } from '../statusColors';
import { statusIconComponent } from '../statusIcons';

// Solid status pill: 22px tall, 12px/500 uppercase, roomier than ClickUp's 20px.
// An optional status icon sits before the label in the horizontal pill (the collapsed, vertical pill stays text-only).
// noIconDot: a status with no icon shows a filled dot in the text colour instead (list only; the board keeps none).
const StatusPill = ({ color, icon: Icon = null, children, vertical = false, sx = {}, noIconDot = false }) => (
    <Box
        component="span"
        sx={{
            display: 'inline-flex', alignItems: 'center', gap: '4px',
            backgroundColor: color, color: readableText(color),
            borderRadius: '6px', p: vertical ? '10px 3px' : '3px 10px', minHeight: vertical ? undefined : 22,
            fontSize: '0.75rem', fontWeight: 500, textTransform: 'uppercase',
            lineHeight: '16px', whiteSpace: 'nowrap', maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis',
            ...(vertical && { writingMode: 'vertical-rl' }),
            ...sx,
        }}
    >
        {Icon && !vertical && <Icon sx={{ fontSize: 14, flexShrink: 0 }} />}
        {!Icon && noIconDot && !vertical && (
            <Box component="span" aria-hidden sx={{ width: 9, height: 9, mx: '2px', borderRadius: '50%', bgcolor: 'currentColor', flexShrink: 0 }} />
        )}
        {children}
    </Box>
);

// Colour + icon for a Deal Flow list status ({ value: _id, mappedValue }); the board keys defaults by mappedValue.
export const listStatusMeta = (status) => ({
    color: statusColor({ ...status, value: status?.mappedValue ?? status?.value }),
    Icon: statusIconComponent(status),
});

// A status's own icon in its colour (a dot when it has none) - for menus that list statuses.
export const StatusOptionIcon = ({ status, size = 18 }) => {
    const { color, Icon } = listStatusMeta(status);
    return Icon
        // Inline colour: menus often grey every svg in a row (e.g. the bulk bar), which would hide the status colour.
        ? <Icon sx={{ fontSize: size, flexShrink: 0 }} style={{ color }} />
        : <Box component="span" sx={{ width: 10, height: 10, mx: `${(size - 10) / 2}px`, borderRadius: '50%', bgcolor: color, flexShrink: 0 }} />;
};

export default StatusPill;
